module.exports = __webpack_public_path__ + "static/media/IMG_0679y.8e96999e.jpg";